import { Fragment } from "preact";
import Link from "../link";
import namedRoutes from "../../settings/routes";

const AffiliateDisclosureContent = () => {
  return (
    <Fragment>
      <p>
        <strong>
          I'm an independent creator and I'm not sponsored by the brands whose
          products I review.
        </strong>{" "}
        While I sometimes receive products or review samples from brands for
        testing, I don't accept requirements that dictate my conclusions,
        require specific messaging, or restrict what I can say about a product.
        This allows me to highlight both the strengths and the flaws of every
        product. Products featured in my articles, videos, and other content may
        be review samples, loaned products, or items purchased independently.
        Learn more about my{" "}
        <Link href={namedRoutes.about}>review philosophy and background</Link>.
      </p>

      <h3>Affiliate Links</h3>
      <p>
        Some links in my content are affiliate links. If you click a link and
        make a purchase, I may earn a small commission at{" "}
        <strong>no extra cost to you</strong>. These commissions help keep my
        work sustainable as an independent creator, and your support truly means
        a lot. Thanks for reading and for supporting independent reviews!
      </p>

      <h3>Coupon Codes</h3>
      <p>
        To help my readers save money, I’ve secured custom coupon codes with
        some brands. When you use one of these codes, it may generate an
        affiliate commission for me, similar to clicking an affiliate link.
        These codes <strong>never increase your price</strong> and offer a great
        discount to help you save. They also let brands know you came from my
        content, which helps support future testing, reviews, and guides.
      </p>

      <h3>Affiliate Programs</h3>
      <p>I currently use the following affiliate programs:</p>
      <ul>
        <li>
          <strong>Amazon:</strong> As an{" "}
          <Link href="https://affiliate-program.amazon.com/">
            Amazon Associate
          </Link>{" "}
          I earn from qualifying purchases.
        </li>
        <li>
          <strong>Awin:</strong> I use{" "}
          <Link
            href="https://www.awin.com/"
            affiliate={`https://www.awin1.com/cread.php?awinmid=4032&awinaffid=${process.env.AFFILIATE_AWIN_PUBLISHER_ID}&ued=https%3A%2F%2Fwww.awin.com%2F`}
          >
            Awin
          </Link>{" "}
          for affiliate links and coupon‑code attribution for certain brands.
        </li>
        <li>
          <strong>Affiliatly:</strong> I use{" "}
          <Link href="https://www.affiliatly.com/">Affiliatly</Link> for
          affiliate links and coupon‑code attribution for certain brands.
        </li>
      </ul>

      <p>Thank you for trusting me to help you make informed decisions.</p>

      <hr />

      <p>
        To learn more about how affiliate networks and third-party tracking
        technologies handle visitor data, please read our full{" "}
        <Link href={namedRoutes.terms}>Terms of Use</Link> and{" "}
        <Link href={namedRoutes.privacy}>Privacy Policy</Link>.
      </p>
    </Fragment>
  );
};

export default AffiliateDisclosureContent;
